import Vue from 'vue'

export const SET_USER_DATA = (state, { userData }) => {
  state.user = { ...userData }
  localStorage.setItem('dcmweb', JSON.stringify(state.user))
}

export const UPDATE_USER_TOKEN = (state, { newToken }) => {
  state.user.token = newToken.token
  state.user.refresh_token = newToken.refresh_token
  localStorage.setItem('dcmweb', JSON.stringify(state.user))
}

export const UPDATE_REPORTS = (state, { updateReports }) => {
  state.updateReports = updateReports
}

export const SET_ERROR = (state, { errorMsg }) => {
  state.error = errorMsg
}

export const SHOW_OVERLAY = (state, { show }) => {
  state.overlay = show
}

export const SET_SUCCESS = (state, { successMsg }) => {
  state.success = successMsg
}

export const SET_INFO = (state, { infoMsg }) => {
  state.info = infoMsg
}

export const SET_SETTINGS = (state, { settings }) => {
  state.settings = { ...settings }
}

export const SET_TOTAL_REPORTS = (state, { total }) => {
  state.totalReport = { ...total }
}

export const SHOW_SETTINGS = (state, { show }) => {
  state.showSettings = show
}

export const SHOW_TASK_DIALOG = (state, { show }) => {
  state.showTaskDialog = show
}

export const SHOW_DETAILS_DIALOG = (state, { show }) => {
  state.showDetailsDialog = { ...show }
}

export const SHOW_CONFIRM_DENIED_DIALOG = (state, { show }) => {
  state.showConfirmDeniedDialog = show
}

export const SET_SELECTED_PROJECT = (state, { selectedProject }) => {
  state.selectedProject = selectedProject
}

export const SET_SELECTED_PROJECT_NAME = (state, { selectedProjectName }) => {
  state.selectedProjectName = selectedProjectName
}

export const SET_CURRENT_TASKS_LIST = (state, { tasksList }) => {
  state.currentTasksList = tasksList
  state.estRepTasks = {}
}

export const SET_IS_LOADING = (state, { isLoading }) => {
  state.isLoading = isLoading
}

export const SET_EMPLOYEE_LIST = (state, { employeeList }) => {
  state.employeeList = employeeList
}

export const SET_CURRENT_TASK_DATA = (state, { taskData }) => {
  state.currentTaskData = taskData
}

export const UPDATE_TASKS = (state, { update }) => {
  state.updateTasks = update
}

export const ADD_USER_ON_PROJECT = (state, { userId }) => {
  if (!state.usersOnProject.includes(userId)) {
    state.usersOnProject.push(userId)
  }
}

export const SET_USERS_ON_PROJECT = (state, { users }) => {
  state.usersOnProject = Array.from(new Set(users))
}

export const ADD_PARENT_TASK_ON_PROJECT = (state, { parentTask }) => {
  state.parentTasksOnProject.push(parentTask)
}

export const UPDATE_STATE_OF_OPENED_FOLDERS = (state, { taskId, isOpen }) => {
  Vue.set(state.stateOfOpenedFolders, taskId, isOpen)
}

export const RESET_OPENED_FOLDERS = (state) => {
  state.stateOfOpenedFolders = {}
}

export const SAVE_EMPLOYEE_INFORMATION = (state, { employee }) => {
  Vue.set(state.employee, employee.Employee_ID, employee)
}

export const ADD_EMPLOYEE = (state, { employee }) => {
  if (employee.length) {
    for (let i = 0; i < employee.length; i++) {
      if (state.employee.filter(empl => empl.Employee_ID === employee[i].Employee_ID)[0]) continue
      state.employee.push(employee[i])
    }
  } else {
    if (state.employee.filter(empl => empl.Employee_ID === employee.Employee_ID)[0]) return false
    state.employee.push(employee)
  }
}

export const ADD_EMPLOYEE_STATUS = (state, { employeeId, status }) => {
  let emplI = 0
  const empl = state.employee.filter((empl, i) => {
    if (empl.Employee_ID === employeeId) {
      emplI = i
      return true
    }
  })[0]
  if (empl) {
    empl.Empl_Status_History.push(status)
    empl.Status = status.Status_Descr
    empl.Status_ID = status.Status_ID
    Vue.set(state.employee, emplI, empl)
  }
}

export const REMOVE_EMPLOYEE_STATUS = (state, { employeeId, index }) => {
  for (let i = 0; i < state.employee.length; i++) {
    if (state.employee[i].Employee_ID === employeeId) {
      state.employee[i].Empl_Status_History.splice(index, 1)
      if (state.employee[i].Empl_Status_History.length) {
        const last = state.employee[i].Empl_Status_History[state.employee[i].Empl_Status_History.length - 1]
        state.employee[i].Status = last.Status_Descr
        state.employee[i].Status_ID = last.Status_ID
      } else {
        state.employee[i].Status = null
        state.employee[i].Status_ID = null
      }
      return false
    }
  }
}

export const UPDATE_EMPLOYEE_STATUS = (state, { employeeId, statuses }) => {
  for (let i = 0; i < state.employee.length; i++) {
    if (state.employee[i].Employee_ID === employeeId) {
      Vue.set(state.employee[i].Empl_Status_History, statuses)
      const last = state.employee[i].Empl_Status_History[state.employee[i].Empl_Status_History.length - 1]
      state.employee[i].Status = last.Status_Descr
      state.employee[i].Status_ID = last.Status_ID
    }
  }
}

export const SET_EMPLOYEE_RATE = (state, { rate, employeeId }) => {
  if (state.employeeDetailsScreen.show) {
    state.employeeDetailsScreen.employee.Employee_Rate = rate
  } else {
    for (let i = 0; i < state.employee.length; i++) {
      if (state.employee[i].Employee_ID === employeeId) {
        state.employee[i].Employee_Rate = rate
        break
      }
    }
  }
}

export const ADD_EMPLOYEE_RATE = (state, { rate }) => {
  for (let i = 0; i < state.employee.length; i++) {
    if (state.employee[i].Employee_ID === rate.Employee_ID) {
      state.employee[i].Employee_Rate.push(rate)
      break
    }
  }
}

export const UPDATE_EMPLOYEE_RATE = (state, { rate }) => {
  for (let i = 0; i < state.employee.length; i++) {
    if (state.employee[i].Employee_ID === rate.Employee_ID) {
      for (let j = 0; j < state.employee[i].Employee_Rate.length; j++) {
        if (state.employee[i].Employee_Rate[j].Employee_Rate_ID === rate.Employee_Rate_ID) {
          state.employee[i].Employee_Rate.splice(j, 1, { ...rate })
          break
        }
      }
      break
    }
  }
}

export const REMOVE_EMPLOYEE_RATE = (state, { rate }) => {
  for (let i = 0; i < state.employee.length; i++) {
    if (state.employee[i].Employee_ID === rate.Employee_ID) {
      for (let j = 0; j < state.employee[i].Employee_Rate.length; j++) {
        if (state.employee[i].Employee_Rate[j].Employee_Rate_ID === rate.Employee_Rate_ID) {
          state.employee[i].Employee_Rate.splice(j, 1)
          break
        }
      }
      break
    }
  }
}

export const UPDATE_EMPLOYEE = (state, { employee }) => {
  let emplI = 0
  const empl = state.employee.filter((empl, i) => {
    if (empl.Employee_ID === employee.Employee_ID) {
      emplI = i
      return true
    }
  })[0]
  if (empl) {
    Vue.set(state.employee, emplI, employee)
  }
}

export const ADD_EST_REP_FOR_TASK = (state, { taskId, est, rep }) => {
  Vue.set(state.estRepTasks, taskId, { est, rep })
}

export const REMOVE_PARENT_TASKS_ON_PROJECT = (state) => {
  state.parentTasksOnProject = [
    {
      Task_ID: null,
      Name: '-- root --'
    }
  ]
}

export const REMOVE_USERS_ON_PROJECT = (state) => {
  state.usersOnProject = []
}

export const IS_DRAGGING = (state, { dragging }) => {
  state.dragging = dragging
}

export const SET_STATUSES = (state, { statuses }) => {
  state.statuses = statuses
}

export const SET_ACTIVITY_TYPES = (state, { activityTypes }) => {
  state.activityTypes = []
  activityTypes.forEach(item => {
    if (item.Active) {
      state.activityTypes.push({
        Activity_Type: item.Activity_Type,
        Description: item.Description
      })
    }
  })
}

export const SET_PERMISSIONS = (state, { permissionsFor, permissions }) => {
  state.permissions[permissionsFor] = []
  state.permissions[permissionsFor] = permissions
}

export const SET_DEPARTMENTS = (state, { departments }) => {
  state.departments = departments
}

export const SET_CONTRACT_TYPES = (state, { contractTypes }) => {
  state.contract_types = contractTypes
}

export const SET_WORK_LOCATIONS = (state, { locations }) => {
  state.work_locations = locations
}

export const SET_CLIENTS = (state, { clients }) => {
  state.clients = clients
}

export const ADD_CLIENT = (state, { client }) => {
  state.clients.push(client)
}

export const UPDATE_CLIENT = (state, { client }) => {
  const ind = state.clients.findIndex(cl => cl.Client_ID === client.Client_ID)
  Vue.set(state.clients, ind, client)
}

export const SET_PROJECTS = (state, { projects }) => {
  state.projects = projects
}

export const ADD_PROJECT = (state, { project }) => {
  state.projects.push(project)
}

export const UPDATE_PROJECT = (state, { project }) => {
  const ind = state.projects.findIndex(pr => pr.Project_ID === project.Project_ID)
  Vue.set(state.projects, ind, project)
}

export const SET_PROJECT_STATUSES = (state, { projectStatuses }) => {
  state.projectStatuses = projectStatuses
}

export const SET_MANAGERS_FOR_PROJECT = (state, { projectId, managers }) => {
  state.projectManagementHistory[projectId] = managers
}

export const SET_RATE_HISTORY_FOR_PROJECT = (state, { projectId, history }) => {
  state.projectRateHistory[projectId] = history
}

export const SET_NOTIFICATIONS = (state, { notifications }) => {
  state.notifications = notifications
}

export const SET_EMPLOYEE_ROLES = (state, { roles }) => {
  for (let i = 0; i < roles.length; i++) {
    const role = roles[i].RoleName.toLowerCase()
    if (state.employeeRoles[role]) {
      state.employeeRoles[role].val = true
    }
  }
}

export const SET_EMAIL_CONFIG_ELEMENT = (state, { element }) => {
  state.currentEmailConfigElement = element
}

export const SET_EMAIL_TEMPLATES_LIST = (state, { emailTemplatesList }) => {
  state.emailTemplates = emailTemplatesList
}

export const UPDATE_EMAIL_TEMPLATE = (state, { template }) => {
  let templI = 0
  const templ = state.emailTemplates.filter((t, i) => {
    if (t.ID === template.ID) {
      templI = i
      return true
    }
  })[0]
  if (templ) {
    Vue.set(state.emailTemplates, templI, template)
  }
}

export const ADD_EMAIL_TEMPLATE = (state, { template }) => {
  state.emailTemplates.push(template)
}

export const REMOVE_EMAIL_TEMPLATE = (state, { templateID }) => {
  state.emailTemplates = state.emailTemplates.filter(et => et.ID !== templateID)
}

export const TOGGLE_EMPLOYEE_FULL_NAME_BUTTON = (state) => {
  state.employeeNameClicked = !state.employeeNameClicked
}

export const UPDATE_POLICY = (state, { policy }) => {
  let policyI = 0
  const _policy = state.policies.filter((p, i) => {
    if (p.Policy_ID === policy.Policy_ID) {
      policyI = i
      return true
    }
  })[0]
  if (_policy) {
    Vue.set(state.policies, policyI, policy)
  }
}

export const ADD_POLICY = (state, { policy }) => {
  state.policies.push(policy)
}

export const SET_POLICIES = (state, { policies }) => {
  state.policies = policies
}

export const SET_POLICY_USERS = (state, { policyUsers }) => {
  state.policyUsers = policyUsers
}

export const REMOVE_POLICY = (state, { policyId }) => {
  state.policies = state.policies.filter(p => p.Policy_ID !== policyId)
}

export const BLOCK_PROJECT = (state, { projectID }) => {
  state.blockedProject = projectID
}

export const TOGGLE_TASK_TO_SELECTED = (state, { task, action }) => {
  if (action === 'reset') {
    state.selectedTasks = {}
  }
  if (action === 'add') {
    if (!state.selectedTasks[task.Parent_Task_ID]) Vue.set(state.selectedTasks, task.Parent_Task_ID, [])
    if (state.selectedTasks[task.Parent_Task_ID].indexOf(task.Task_ID) === -1) state.selectedTasks[task.Parent_Task_ID].push(task.Task_ID)
  }
  if (action === 'remove' && state.selectedTasks[task.Parent_Task_ID]) {
    let ind = -1
    const a = state.selectedTasks[task.Parent_Task_ID].filter((item, index) => {
      if (item === task.Task_ID) ind = index
      return item === task.Task_ID
    })
    if (ind >= 0 && a.length) {
      state.selectedTasks[task.Parent_Task_ID].splice(ind, 1)
    }
  }
}

export const SET_DIVISION_LIST = (state, { divisions }) => {
  state.divisions = divisions
}

export const SET_INVOICES = (state, { invoices }) => {
  state.invoices = invoices
}

export const UPDATE_INVOICE = (state, { invoice }) => {
  let invoiceI = 0
  const _invoice = state.invoices.find((i, ind) => {
    if (i.Invoice_ID === invoice.Invoice_ID) {
      invoiceI = ind
      return true
    }
  })
  if (_invoice) {
    Vue.set(state.invoices, invoiceI, invoice)
  }
}

export const ADD_INVOICE = (state, { invoice }) => {
  state.invoices.push(invoice)
}

export const UPDATE_SALARY = (state, { update }) => {
  state.updateSalary = update
}

export const EMPLOYEE_DETAILS_SCREEN = (state, { show, employee, edit }) => {
  state.employeeDetailsScreen.show = show
  state.employeeDetailsScreen.employee = employee
  state.employeeDetailsScreen.edit = false
}

export const PROJECT_DETAILS_SCREEN = (state, { show, project }) => {
  state.projectDetailsScreen.show = show
  state.projectDetailsScreen.project = project
}

export const CLIENT_DETAILS_SCREEN = (state, { show, client }) => {
  state.clientDetailsScreen.show = show
  state.clientDetailsScreen.client = client
}

export const SHOW_EDIT_TASK_OR_FOLDER_DIALOG = (state, { show, data }) => {
  state.showEditTaskOrFolderDialogData.show = show
  state.showEditTaskOrFolderDialogData.data = data
}

export const SET_ALERT_ABOUT_DELETE_DIALOG_DATA = (state, { show, data }) => {
  state.alertAboutDeleteDialogData.show = show
  state.alertAboutDeleteDialogData.data.Is_Folder = data.Is_Folder
  state.alertAboutDeleteDialogData.data.Task_ID = data.Task_ID
  state.alertAboutDeleteDialogData.data.Parent_Task_ID = data.Parent_Task_ID
  state.alertAboutDeleteDialogData.data.Project_ID = data.Project_ID
  state.alertAboutDeleteDialogData.data.Name = data.Name
}

export const UPDATE_TASK = (state, { taskID, self, newData }) => {
  state.updateTask.taskID = taskID
  state.updateTask.self = self
  state.updateTask.newData = newData
}

export const TASK_UPDATED = (state) => {
  state.updateTask.taskID = null
  state.updateTask.self = null
  state.updateTask.newData = null
}

export const SET_ACCESS_TO_CREATE_TASK_EMPL_LIST = (state, { emplList }) => {
  state.accessToCreateTasksEmplList = emplList
}

export const UPDATE_REPORTS_LIST = (state, { update }) => {
  state.updateReportsList = update
}

export const UPDATE_MANAGER_REPORT_STATE = (state, { key, value }) => {
  state.managerReportsState[key] = value
}

export const SET_PROJECT_DETAILS_DIALOG_STATE = (state, { _state }) => {
  state.projectDetailsDialogState = _state
}

export const ASSET_DETAILS_SCREEN = (state, { show, asset, categories, subcategories }) => {
  state.assetDetailsScreen.show = show
  state.assetDetailsScreen.asset = asset
  state.assetDetailsScreen.categories = categories
  state.assetDetailsScreen.subcategories = subcategories
}

export const SET_CURRENT_USER_POSITION = (state, { employeePosition }) => {
  state.employeePosition = employeePosition
}

export const SET_BAD_WORDS = (state, badWords) => {
  state.badWords = badWords
}

export const SHOW_ASSISTANT_PANEL = (state, { show }) => {
  state.assistantPanel = { ...state.assistantPanel, show }
}
